import { generateGuestUsername } from "./guestNames";

const SESSION_KEY = "aeternaInvicta.session";
const GUEST_TTL_MS = 24 * 60 * 60 * 1000;

function readRawSession() {
  try {
    const raw = window.localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch (error) {
    return null;
  }
}

function writeRawSession(payload) {
  try {
    window.localStorage.setItem(SESSION_KEY, JSON.stringify(payload));
  } catch (error) {
    // Ignore quota / private mode failures.
  }
}

export function clearSession() {
  try {
    window.localStorage.removeItem(SESSION_KEY);
  } catch (error) {
    // Ignore storage failures.
  }
}

export function loadSession(now = Date.now()) {
  const saved = readRawSession();
  if (!saved || typeof saved.username !== "string" || !saved.username.trim()) {
    clearSession();
    return null;
  }
  const username = saved.username.trim().slice(0, 40);
  if (/\s/.test(username)) {
    clearSession();
    return null;
  }
  const kind = saved.kind === "account" ? "account" : "guest";
  const token = typeof saved.token === "string" ? saved.token.trim() : "";
  if (kind === "account") {
    if (!token || token === "local" || token === "guest") {
      clearSession();
      return null;
    }
  }
  if (kind === "guest") {
    const expiresAt = Number(saved.expiresAt);
    if (!Number.isFinite(expiresAt) || expiresAt <= now) {
      clearSession();
      return null;
    }
  }
  return {
    kind,
    id: Number(saved.id) || 0,
    username,
    token: token === "local" || token === "guest" ? "" : token,
    expiresAt: kind === "guest" ? Number(saved.expiresAt) || null : null,
  };
}

export function saveAccountSession(user) {
  if (!user?.username) return;
  const token = typeof user.token === "string" ? user.token.trim() : "";
  if (!token || token === "local" || token === "guest") return;
  writeRawSession({
    kind: "account",
    id: Number(user.id) || 0,
    username: String(user.username).trim().slice(0, 40),
    token,
    savedAt: Date.now(),
  });
}

export function saveGuestSession(user, now = Date.now()) {
  if (!user?.username) return;
  const token = typeof user.token === "string" ? user.token.trim() : "";
  writeRawSession({
    kind: "guest",
    id: Number(user.id) || 0,
    username: String(user.username).trim().slice(0, 40),
    token: token && token !== "local" && token !== "guest" ? token : "",
    savedAt: now,
    expiresAt: Number(user.expiresAt) || now + GUEST_TTL_MS,
  });
}

export function createGuestUser() {
  return {
    id: 0,
    username: generateGuestUsername(),
    token: "",
    kind: "guest",
  };
}

export { GUEST_TTL_MS, SESSION_KEY };
